import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';

import {
  getContenderLeftFooterState,
  getSecondaryContenderFooterState,
} from 'lib/contender';

import { LineupFooterStatus } from '../LineupFooterStatus';
import type { SimpleContenderFooterStatus_so5LeaderboardContender } from './__generated__/index.graphql';

type Props = {
  so5LeaderboardContender: SimpleContenderFooterStatus_so5LeaderboardContender;
  variant?: 'PRIMARY' | 'SECONDARY';
};

export const SimpleContenderFooterStatus = ({
  so5LeaderboardContender,
  variant = 'PRIMARY',
}: Props) => {
  const { so5Lineup } = so5LeaderboardContender;
  const so5Ranking = so5Lineup?.so5Rankings.at(0);
  const leftState =
    variant === 'SECONDARY'
      ? getSecondaryContenderFooterState(so5LeaderboardContender)
      : getContenderLeftFooterState(so5LeaderboardContender);
  if (leftState === null || !so5Ranking) {
    return null;
  }

  return (
    <LineupFooterStatus
      leftState={leftState}
      so5Lineup={so5Lineup || undefined}
    />
  );
};

SimpleContenderFooterStatus.fragments = {
  so5LeaderboardContender: gql`
    fragment SimpleContenderFooterStatus_so5LeaderboardContender on So5LeaderboardContender {
      slug
      so5Lineup {
        id
        rewardMultiplier
        so5Rankings {
          id
        }
        ...LineupFooterStatus_lineupInterface
      }
      ...getContenderLeftFooterState_so5LeaderboardContender
      ...getSecondaryContenderFooterState_so5LeaderboardContender
    }
    ${getContenderLeftFooterState.fragments.so5LeaderboardContender}
    ${getSecondaryContenderFooterState.fragments.so5LeaderboardContender}
    ${LineupFooterStatus.fragments.lineupFooterStatus}
  ` as TypedDocumentNode<SimpleContenderFooterStatus_so5LeaderboardContender>,
};
